// Mock data for Pusubet clone

export const heroSlides = [
  {
    id: 1,
    title: '100%',
    subtitle: 'HOŞ GELDİN',
    highlight: 'BONUSU',
    description: 'Yeni üyelerimize özel ilk yatırıma %100 bonus',
    cta: 'Detaylar',
    bg: 'https://images.pexels.com/photos/22605246/pexels-photo-22605246.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    id: 2,
    title: '%50',
    subtitle: 'SPOR YATIRIM',
    highlight: 'BONUSU',
    description: 'Spor severlere özel her yatırımda %50 bonus fırsatı',
    cta: 'Detaylar',
    bg: 'https://images.unsplash.com/photo-1706675780107-7c43cc487928?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxmb290YmFsbCUyMHN0YWRpdW0lMjBuaWdodHxlbnwwfHx8fDE3ODQ4MTI3ODN8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 3,
    title: '%20',
    subtitle: 'ÇEVRİMSİZ ÇEKİM',
    highlight: 'BONUSU',
    description: 'Her yatırıma çevrimsiz %20 bonus imkanı',
    cta: 'Detaylar',
    bg: 'https://images.unsplash.com/photo-1567771097667-472adfa6945a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxnb2xkJTIwY29pbnN8ZW58MHx8fGJsYWNrfDE3ODQ4MTI3Mzh8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 4,
    title: '%15',
    subtitle: 'KAYIP',
    highlight: 'BONUSU',
    description: 'Haftalık kayıplarınıza %15 iade garantisi',
    cta: 'Detaylar',
    bg: 'https://images.pexels.com/photos/7594180/pexels-photo-7594180.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
];

export const categories = [
  {
    id: 'slot',
    title: 'SLOT',
    subtitle: 'OYUNLARI',
    cta: 'Hemen Oyna',
    href: '/slotlar',
    img: 'https://images.unsplash.com/photo-1521364577880-a15e92cbff6f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxzbG90JTIwbWFjaGluZXxlbnwwfHx8YmxhY2t8MTc4NDgxMjcyNnww&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'canli',
    title: 'CANLI',
    subtitle: 'CASINO',
    cta: 'Hemen Oyna',
    href: '/canli-casino',
    img: 'https://images.pexels.com/photos/7594343/pexels-photo-7594343.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    id: 'spor',
    title: 'SPOR',
    subtitle: 'BAHİSLERİ',
    cta: 'Hemen Oyna',
    href: '/spor',
    img: 'https://images.unsplash.com/photo-1608245449230-4ac19066d2d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxiYXNrZXRiYWxsJTIwYWN0aW9ufGVufDB8fHx8MTc4NDgxMjc4M3ww&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'crash',
    title: 'CRASH',
    subtitle: 'OYUNLARI',
    cta: 'Hemen Oyna',
    href: '/crash',
    img: 'https://images.unsplash.com/photo-1567771097667-472adfa6945a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxnb2xkJTIwY29pbnN8ZW58MHx8fGJsYWNrfDE3ODQ4MTI3Mzh8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'bonus',
    title: 'BONUS',
    subtitle: 'KAMPANYALARI',
    cta: 'Hemen Al',
    href: '/promosyonlar',
    img: 'https://images.unsplash.com/photo-1607344645866-009c320b63e0?crop=entropy&cs=srgb&fm=jpg&w=940&q=85',
  },
];

const slotProviders = ['Pragmatic Play', 'NetEnt', 'Play\u2019n GO', 'Push Gaming', 'Hacksaw', 'ELK Studios', 'Nolimit City', 'Relax Gaming'];
const slotThumbs = [
  'https://images.unsplash.com/photo-1521364577880-a15e92cbff6f?w=400&h=400&fit=crop',
  'https://images.unsplash.com/photo-1706129867447-b4f156c46641?w=400&h=400&fit=crop',
  'https://images.pexels.com/photos/31379653/pexels-photo-31379653.jpeg?auto=compress&w=400',
  'https://images.unsplash.com/photo-1604345250885-11f528eec3ff?w=400&h=400&fit=crop',
  'https://images.unsplash.com/photo-1615229480528-6b8f0f663e33?w=400&h=400&fit=crop',
  'https://images.unsplash.com/photo-1622975696911-c1c444035f43?w=400&h=400&fit=crop',
  'https://images.unsplash.com/photo-1597042962047-005b63a5eb25?w=400&h=400&fit=crop',
  'https://images.unsplash.com/photo-1609769322709-2de28ae6503a?w=400&h=400&fit=crop',
];

const slotNames = [
  'Sweet Bonanza', 'Gates of Olympus', 'Sugar Rush', 'Wanted Dead or a Wild', 'Book of Dead',
  'Le Bandit', 'Big Bass Bonanza', 'Starburst', 'Mental', 'San Quentin', 'Fire in the Hole',
  'The Dog House', 'Money Train 3', 'Reactoonz', 'Razor Shark', 'Aztec Magic', 'Wolf Gold',
  'Gonzo\u2019s Quest', 'Immortal Romance', 'Dead or Alive II', 'Book of Ra', 'Mustang Gold',
  'Buffalo King', 'Rise of Olympus', 'Jammin Jars', 'Cash Elevator', 'Fruit Party', 'Zeus vs Hades',
  'Big Bamboo', 'Tombstone RIP', 'Aztec Bonanza', 'John Hunter'
];

export const slotGames = slotNames.map((name, i) => ({
  id: `slot-${i + 1}`,
  name,
  provider: slotProviders[i % slotProviders.length],
  img: slotThumbs[i % slotThumbs.length],
  rtp: (95 + Math.random() * 3).toFixed(2),
  hot: i % 5 === 0,
  new: i % 7 === 0,
}));

export const slotCategories = [
  { id: 'all', name: 'Tümü' },
  { id: 'hot', name: 'Popüler' },
  { id: 'new', name: 'Yeni' },
  { id: 'megaways', name: 'Megaways' },
  { id: 'jackpot', name: 'Jackpot' },
  { id: 'classic', name: 'Klasik' },
];

export const liveCasinoGames = [
  { id: 'lc-1', name: 'Lightning Roulette', provider: 'Evolution', players: 1284, img: 'https://images.pexels.com/photos/7594343/pexels-photo-7594343.jpeg?w=400' },
  { id: 'lc-2', name: 'Crazy Time', provider: 'Evolution', players: 3421, img: 'https://images.pexels.com/photos/7594180/pexels-photo-7594180.jpeg?w=400' },
  { id: 'lc-3', name: 'Monopoly Live', provider: 'Evolution', players: 892, img: 'https://images.unsplash.com/photo-1604345250885-11f528eec3ff?w=400' },
  { id: 'lc-4', name: 'Speed Baccarat A', provider: 'Evolution', players: 342, img: 'https://images.unsplash.com/photo-1615229480528-6b8f0f663e33?w=400' },
  { id: 'lc-5', name: 'Immersive Roulette', provider: 'Evolution', players: 1102, img: 'https://images.unsplash.com/photo-1597042962047-005b63a5eb25?w=400' },
  { id: 'lc-6', name: 'Dream Catcher', provider: 'Evolution', players: 621, img: 'https://images.unsplash.com/photo-1622975696911-c1c444035f43?w=400' },
  { id: 'lc-7', name: 'Mega Ball', provider: 'Evolution', players: 812, img: 'https://images.unsplash.com/photo-1609769322709-2de28ae6503a?w=400' },
  { id: 'lc-8', name: 'Deal or No Deal', provider: 'Evolution', players: 502, img: 'https://images.pexels.com/photos/8442324/pexels-photo-8442324.jpeg?w=400' },
  { id: 'lc-9', name: 'Blackjack VIP', provider: 'Pragmatic Live', players: 233, img: 'https://images.unsplash.com/photo-1521364577880-a15e92cbff6f?w=400' },
  { id: 'lc-10', name: 'Auto Roulette', provider: 'Pragmatic Live', players: 456, img: 'https://images.unsplash.com/photo-1706129867447-b4f156c46641?w=400' },
  { id: 'lc-11', name: 'ONE Blackjack', provider: 'Pragmatic Live', players: 178, img: 'https://images.pexels.com/photos/31379653/pexels-photo-31379653.jpeg?w=400' },
  { id: 'lc-12', name: 'Sweet Bonanza CandyLand', provider: 'Pragmatic Live', players: 2001, img: 'https://images.unsplash.com/photo-1567771097667-472adfa6945a?w=400' },
];

export const sportsMatches = [
  { id: 'm1', league: 'Süper Lig', home: 'Galatasaray', away: 'Fenerbahçe', time: 'Bugün 20:00', odds: { '1': '1.85', 'X': '3.60', '2': '4.20' }, live: false },
  { id: 'm2', league: 'Premier League', home: 'Manchester City', away: 'Liverpool', time: 'Bugün 22:00', odds: { '1': '2.10', 'X': '3.50', '2': '3.20' }, live: true, score: '1-0', minute: 42 },
  { id: 'm3', league: 'La Liga', home: 'Real Madrid', away: 'Barcelona', time: 'Yarın 22:00', odds: { '1': '2.05', 'X': '3.70', '2': '3.40' }, live: false },
  { id: 'm4', league: 'Bundesliga', home: 'Bayern Münih', away: 'Dortmund', time: 'Yarın 19:30', odds: { '1': '1.65', 'X': '4.20', '2': '4.80' }, live: false },
  { id: 'm5', league: 'Serie A', home: 'Juventus', away: 'Inter', time: 'Bugün 21:45', odds: { '1': '2.80', 'X': '3.10', '2': '2.65' }, live: true, score: '0-1', minute: 67 },
  { id: 'm6', league: 'Ligue 1', home: 'PSG', away: 'Marseille', time: 'Pazar 22:00', odds: { '1': '1.45', 'X': '4.80', '2': '6.50' }, live: false },
  { id: 'm7', league: 'Champions League', home: 'Arsenal', away: 'Bayern', time: 'Salı 22:00', odds: { '1': '2.40', 'X': '3.40', '2': '2.95' }, live: false },
  { id: 'm8', league: 'Süper Lig', home: 'Beşiktaş', away: 'Trabzonspor', time: 'Pazar 19:00', odds: { '1': '1.95', 'X': '3.50', '2': '3.80' }, live: false },
];

export const sportsCategories = [
  { id: 'football', name: 'Futbol', count: 342, icon: 'Trophy' },
  { id: 'basketball', name: 'Basketbol', count: 128, icon: 'Circle' },
  { id: 'tennis', name: 'Tenis', count: 89, icon: 'CircleDot' },
  { id: 'volleyball', name: 'Voleybol', count: 42, icon: 'Volleyball' },
  { id: 'ice', name: 'Buz Hokeyi', count: 31, icon: 'Snowflake' },
  { id: 'esports', name: 'E-Spor', count: 67, icon: 'Gamepad2' },
];

export const promotions = [
  { id: 'p1', title: '%100 Hoş Geldin Bonusu', description: 'Yeni üyelerimize özel ilk yatırım bonusu. Anında hesabınıza yansır.', badge: 'YENİ ÜYE', img: 'https://images.pexels.com/photos/22605246/pexels-photo-22605246.png?auto=compress&w=800' },
  { id: 'p2', title: '%50 Spor Yatırım Bonusu', description: 'Spor bahisleri için her yatırımınıza %50 bonus.', badge: 'SPOR', img: 'https://images.unsplash.com/photo-1706675780107-7c43cc487928?w=800' },
  { id: 'p3', title: '%15 Çevrimsiz Kayıp Bonusu', description: 'Haftalık kayıplarınıza çevrimsiz iade bonusu.', badge: 'KAYIP', img: 'https://images.unsplash.com/photo-1567771097667-472adfa6945a?w=800' },
  { id: 'p4', title: '%20 Slot Yatırım Bonusu', description: 'Slot oyunları için her yatırıma %20 ekstra.', badge: 'SLOT', img: 'https://images.unsplash.com/photo-1521364577880-a15e92cbff6f?w=800' },
  { id: 'p5', title: 'VIP Doğum Günü Bonusu', description: 'VIP üyelerimize özel doğum günü sürprizi.', badge: 'VIP', img: 'https://images.unsplash.com/photo-1615229480528-6b8f0f663e33?w=800' },
  { id: 'p6', title: '%30 Yatırım Çevrimsiz', description: 'Havale yatırımlarına çevrimsiz %30 bonus.', badge: 'YATIRIM', img: 'https://images.unsplash.com/photo-1609769322709-2de28ae6503a?w=800' },
  { id: 'p7', title: 'Arkadaşını Getir 500₺', description: 'Her arkadaş davetinde 500₺ hediye bonus.', badge: 'DAVET', img: 'https://images.pexels.com/photos/8442324/pexels-photo-8442324.jpeg?w=800' },
  { id: 'p8', title: 'Canlı Casino %25 Bonus', description: 'Canlı casino masalarına özel %25 bonus.', badge: 'CANLI', img: 'https://images.pexels.com/photos/7594343/pexels-photo-7594343.jpeg?w=800' },
];

export const providers = [
  'Pragmatic Play', 'NetEnt', 'Evolution', 'Play\u2019n GO', 'Push Gaming',
  'Hacksaw Gaming', 'Nolimit City', 'ELK Studios', 'Relax Gaming', 'Yggdrasil',
  'BTG', 'Quickspin', 'Betsoft', 'Blueprint', 'Red Tiger', 'Microgaming'
];
